import { Component } from "react";
import withAuth from "../../components/withAuth";
import { withStyles } from "@mui/styles";
import { compose } from "redux";
import { connect } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import "moment/locale/fr";
import { setAbsenceCreationFieldsAndGenerateDetails, setAbsenceDetails } from "../../redux/absences/absencesActions";
import { TYPING_TIMEOUT } from "../../constants";
import CustomizedTextField from "../../components/Input/CustomizedTextField";
import DatePicker from "../../components/Input/DatePicker";
import { FormControl, InputLabel } from "@mui/material";
import CustomizedSelect from "../../components/Input/CustomizedSelect";

const styles = (theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(3),
        overflowX: "auto",
    },
    table: {
        minWidth: 700,
    },
    row: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.default,
        },
    },
});

class AbsenceFieldsForm extends Component {
    constructor(props) {
        super(props);

        let selectedValue = props.absences.absenceCreationFields.defaultAbsenceTypeId;

        if (!selectedValue && props.absences.activityTypes.length > 0) {
            selectedValue = props.absences.activityTypes.filter(
                (at) => at.report_type === props.activeUser.weekly_report_type
            )[0].id;
        }

        this.state = {
            selectedActivityTypeId: selectedValue,
            activityTypes: props.absences.activityTypes,
            comment: props.absences.absenceCreationFields.comment,
        };
    }

    componentDidMount() {
        this.timer = null;
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let modifiedState = prevState;

        if (prevState.activityTypes !== nextProps.absences.activityTypes) {
            modifiedState.activityTypes = nextProps.absences.activityTypes.filter(
                (at) => at.report_type === nextProps.activeUser.weekly_report_type
            );
        }

        if (prevState.selectedActivityTypeId !== nextProps.absences.absenceCreationFields.defaultAbsenceTypeId) {
            modifiedState.selectedActivityTypeId = nextProps.absences.absenceCreationFields.defaultAbsenceTypeId;
        }

        let selectedValue = nextProps.absences.absenceCreationFields.defaultAbsenceTypeId;

        if (!selectedValue && nextProps.absences.activityTypes.length > 0) {
            modifiedState.selectedActivityTypeId = nextProps.absences.activityTypes.filter(
                (at) => at.report_type === nextProps.activeUser.weekly_report_type
            )[0].id;
        }

        return modifiedState;
    }

    defaultActivityTypeHandler(value) {
        this.props.setAbsenceCreationFieldsAndGenerateDetails(
            this.props.absences.absenceCreationFields.id,
            this.props.absences.absenceCreationFields.employeeId,
            value.target.value,
            this.props.absenceDetails,
            this.props.absences.absenceCreationFields.status,
            this.props.absences.absenceCreationFields.counters,
            this.props.absences.absenceCreationFields.date_from,
            this.props.absences.absenceCreationFields.date_to,
            this.props.absences.absenceCreationFields.comment,
            this.props.activeUser.id
        );
    }

    defaultEmployeeHandler(value) {
        this.props.setAbsenceCreationFieldsAndGenerateDetails(
            this.props.absences.absenceCreationFields.id,
            value.target.value,
            this.props.absences.absenceCreationFields.defaultAbsenceTypeId,
            this.props.absenceDetails,
            this.props.absences.absenceCreationFields.status,
            this.props.absences.absenceCreationFields.counters,
            this.props.absences.absenceCreationFields.date_from,
            this.props.absences.absenceCreationFields.date_to,
            this.props.absences.absenceCreationFields.comment,
            this.props.activeUser.id
        );
    }

    onDateStartChange(value) {
        let dateEnd = this.props.absences.absenceCreationFields.date_to;

        if (value > this.props.absences.absenceCreationFields.date_to) dateEnd = value;

        this.props.setAbsenceCreationFieldsAndGenerateDetails(
            this.props.absences.absenceCreationFields.id,
            this.props.absences.absenceCreationFields.employeeId,
            this.props.absences.absenceCreationFields.defaultAbsenceTypeId,
            this.props.absenceDetails,
            this.props.absences.absenceCreationFields.status,
            this.props.absences.absenceCreationFields.counters,
            value,
            dateEnd,
            this.props.absences.absenceCreationFields.comment,
            this.props.activeUser.id
        );
    }

    onDateEndChange(value) {
        let dateStart = this.props.absences.absenceCreationFields.date_from;

        if (value < this.props.absences.absenceCreationFields.date_from) dateStart = value;

        this.props.setAbsenceCreationFieldsAndGenerateDetails(
            this.props.absences.absenceCreationFields.id,
            this.props.absences.absenceCreationFields.employeeId,
            this.props.absences.absenceCreationFields.defaultAbsenceTypeId,
            this.props.absenceDetails,
            this.props.absences.absenceCreationFields.status,
            this.props.absences.absenceCreationFields.counters,
            dateStart,
            value,
            this.props.absences.absenceCreationFields.comment,
            this.props.activeUser.id
        );
    }

    onCommentChange(e) {
        clearTimeout(this.timer);

        this.setState({
            comment: e.target.value,
        });

        this.timer = setTimeout(this.triggerChange.bind(this), TYPING_TIMEOUT);
    }

    triggerChange() {
        const { comment } = this.state;

        this.props.setAbsenceCreationFieldsAndGenerateDetails(
            this.props.absences.absenceCreationFields.id,
            this.props.absences.absenceCreationFields.employeeId,
            this.props.absences.absenceCreationFields.defaultAbsenceTypeId,
            this.props.absenceDetails,
            this.props.absences.absenceCreationFields.status,
            this.props.absences.absenceCreationFields.counters,
            this.props.absences.absenceCreationFields.date_from,
            this.props.absences.absenceCreationFields.date_to,
            comment,
            this.props.activeUser.id
        );
    }

    render() {
        let rowsActivityTypes = [];
        for (let i = 0; i < this.state.activityTypes.length; i++) {
            let currentActivityType = this.state.activityTypes[i];

            rowsActivityTypes.push(
                <MenuItem key={i} value={currentActivityType.id}>
                    {currentActivityType.name}
                </MenuItem>
            );
        }

        return (
            <div className="row full-height">
                <div className=" col-lg-8 col-md-8 col-sm-12 col-12 control-margin-top">
                    <FormControl className="row" sx={{ marginTop: "16px" }}>
                        <InputLabel id="defaultActivityType-label">{"Type d'absence par défaut"}</InputLabel>
                        <CustomizedSelect
                            labelId="defaultActivityType-label"
                            id="defaultActivityType"
                            inputProps={{ name: "defaultActivityType", id: "defaultActivityType" }}
                            placeholder="Type d'absence par défaut"
                            label="Type d'absence par défaut"
                            className={"full_size " + (this.props.readonly ? "disabled" : "")}
                            onChange={this.defaultActivityTypeHandler.bind(this)}
                            value={this.state.selectedActivityTypeId}
                        >
                            {rowsActivityTypes}
                        </CustomizedSelect>
                    </FormControl>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-12 control-margin-top">
                    <CustomizedTextField
                        id="nbDays"
                        label={"Nombre de jour"}
                        className={"full_size " + (this.props.readonly ? "disabled" : "")}
                        value={this.props.absences.absenceCreationFields.nbDays.toString()}
                        margin="normal"
                        disabled
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <DatePicker
                        label="Date de début"
                        value={this.props.absences.absenceCreationFields.date_from}
                        emptyLabel="La date est invalide"
                        invalidDateMessage="La date est invalide"
                        invalidLabel="La date est invalide"
                        format="DD/MM/YYYY"
                        className={"col-lg-12 col-md-12 col-sm-12 col-12 " + (this.props.readonly ? "disabled" : "")}
                        onChange={this.onDateStartChange.bind(this)}
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 control-margin-top">
                    <DatePicker
                        label="Date de fin"
                        value={this.props.absences.absenceCreationFields.date_to}
                        emptyLabel="La date est invalide"
                        invalidDateMessage="La date est invalide"
                        invalidLabel="La date est invalide"
                        format="DD/MM/YYYY"
                        className={"col-lg-12 col-md-12 col-sm-12 col-12 " + (this.props.readonly ? "disabled" : "")}
                        onChange={this.onDateEndChange.bind(this)}
                    />
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                    <CustomizedTextField
                        id="comment"
                        label={"Commentaire"}
                        multiline
                        className={"full_size " + (this.props.readonly ? "disabled" : "")}
                        value={this.state.comment}
                        margin="normal"
                        onChange={this.onCommentChange.bind(this)}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
        absenceDetails: state.absences.absenceDetails,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setAbsenceCreationFieldsAndGenerateDetails: (
            id,
            employeeId,
            defaultAbsenceTypeId,
            details,
            status,
            counters,
            dateStart,
            dateEnd,
            comment,
            userId
        ) =>
            dispatch(
                setAbsenceCreationFieldsAndGenerateDetails(
                    id,
                    employeeId,
                    defaultAbsenceTypeId,
                    details,
                    status,
                    counters,
                    dateStart,
                    dateEnd,
                    comment,
                    userId
                )
            ),
        setAbsenceDetails: (absenceDetails) => dispatch(setAbsenceDetails(absenceDetails)),
    };
};

export default compose(withAuth, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(AbsenceFieldsForm);
